import { render, staticRenderFns } from "./newCouponCard.vue?vue&type=template&id=9b2bb514&scoped=true&"
import script from "./newCouponCard.vue?vue&type=script&lang=js&"
export * from "./newCouponCard.vue?vue&type=script&lang=js&"
import style0 from "./newCouponCard.vue?vue&type=style&index=0&id=9b2bb514&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2bb514",
  null
  
)

export default component.exports